import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { OrganizationConfigService } from 'src/app/core/services/configs/organization-config.service';
import { IOrgConfig } from '../models/org-config.interface';

export const configResolver: ResolveFn<IOrgConfig> = () => {
  const orgConfigService = inject(OrganizationConfigService);
  return orgConfigService.orgConfig;
};